module.exports = "<input type=\"text\" class=\"form-control input-sm\" [(ngModel)]=\"date\">"